import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { IBatchTemplate, ITemplate, ITemplateFilterDTO } from '@zunta/configurations'
import Api from '@/api'
import { IBaseStore } from '../types'
import { bus } from '@/plugins/eventBus'

export interface ITemplateState {
    templates: ITemplate[];
    templatesTotal: number;
    selectedTemplate: ITemplate;
}

export interface ITemplateStore extends IBaseStore {
    state: ITemplateState
}

@Module({
    name: 'template',
    namespaced: true
})
export class TemplateModule extends VuexModule {
    templates: ITemplate[] = []
    templatesTotal: number = 0
    selectedTemplate: ITemplate | null = null

    @Mutation
    SET_TEMPLATE_LIST (templates: ITemplate[]) {
        this.templates = templates
    }

    @Mutation
    SET_TEMPLATES_TOTAL (total: number) {
        this.templatesTotal = total
    }

    @Mutation
    SET_SELECTED_TEMPLATE (template: ITemplate | null) {
        this.selectedTemplate = template
    }

    @Action
    async uploadPDFLetter (file: any) {
      const response = await Api.template.uploadPDFLetter(file)
      if (response.statusCode >= 400) {
        return bus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: response.statusCode === 422 ? 'PDF file is invalid' : 'Internal server error',
          header: `PDF Fail`,
          icon: 'warning'
        })
      }
      if (response.messages && response.messages.length) {
        response.messages.forEach((message: string) => {
          bus.$emit('notify', {
            color: 'var(--status-info-color)',
            message,
            header: `PDF Changed`,
            icon: 'info'
          })
        })
      }
      return response.fileName
    }

  @Action
  async uploadPDFLetterForStatement (file: any): Promise<{ fileName: string, messages: string[] }> {
    const response = await Api.template.uploadPDFLetter(file)
    return { fileName: response.fileName, messages: response.messages }
  }

    @Action
    async addTemplate (data: Partial<ITemplate>) {
        const response = await Api.template.addTemplate(data)
        return response
    }

    @Action
    async updateTemplate (input: { templateId: number | string, data: Partial<ITemplate> }) {
        const response = await Api.template.updateTemplate(input.templateId, input.data)
        return response
    }

    @Action
    async fetchTemplates (filters: ITemplateFilterDTO) {
        const { total, templates } = await Api.template.getFilteredTemplates(filters)
        this.SET_TEMPLATE_LIST(templates)
        this.SET_TEMPLATES_TOTAL(total)
    }

    @Action
    async fetchTemplateById (templateId: number | string) {
        const template = await Api.template.getTemplateById(templateId)
        this.SET_SELECTED_TEMPLATE(template)
    }

    @Action
    resetSelectedTemplate () {
        this.SET_SELECTED_TEMPLATE(null)
    }

    @Action
    async deleteTemplate (templateId: string | number) {
        await Api.template.deleteTemplate(templateId)
    }

    @Action
    async getBatchSettingsTemplates (settingsId: number | string) {
        return Api.template.getBatchSettingsTemplates(settingsId)
    }

    @Action
    async updateBatchSettingTemplate (batchTemplate: Partial<IBatchTemplate>) {
        return Api.template.updateBatchSettingTemplate(batchTemplate)
    }

    @Action
    async deleteBatchSettingsTemplates (batchTemplateId: number | string) {
        return Api.template.deleteBatchSettingsTemplates(batchTemplateId)
    }
}
